import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import '@frontdesk/config/src/tokens/tokens.css';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// Easter egg for the curious developers who view the console
if (typeof window !== 'undefined') {
  const banner = `
   ▄████  ██▀███   ▒█████   ███▄    █ ▄▄▄█████▓ ▓█████▄ ▓█████   ██████  ██ ▄█▀
  ██▒ ▀█▒▓██ ▒ ██▒▒██▒  ██▒ ██ ▀█   █ ▓  ██▒ ▓▒ ▒██▀ ██▌▓█   ▀ ▒██    ▒  ██▄█▒
 ▒██░▄▄▄░▓██ ░▄█ ▒▒██░  ██▒▓██  ▀█ ██▒▒ ▓██░ ▒░ ░██   █▌▒███   ░ ▓██▄   ▓███▄░
 ░▓█  ██▓▒██▀▀█▄  ▒██   ██░▓██▒  ▐▌██▒░ ▓██▓ ░  ░▓█▄   ▌▒▓█  ▄   ▒   ██▒▓██ █▄
 ░▒▓███▀▒░██▓ ▒██▒░ ████▓▒░▒██░   ▓██░  ▒██▒ ░  ░▒████▓ ░▒████▒▒██████▒▒▒██▒ █▄
  ░▒   ▒ ░ ▒▓ ░▒▓░░ ▒░▒░▒░ ░ ▒░   ▒ ▒   ▒ ░░     ▒▒▓  ▒ ░░ ▒░ ░▒ ▒▓▒ ▒ ░▒ ▒▒ ▓▒
   ░   ░   ░▒ ░ ▒░  ░ ▒ ▒░ ░ ░░   ░ ▒░    ░      ░ ▒  ▒  ░ ░  ░░ ░▒  ░ ░░ ░▒ ▒░
 ░ ░   ░   ░░   ░ ░ ░ ░ ▒     ░   ░ ░   ░        ░ ░  ░    ░   ░  ░  ░  ░ ░░ ░
       ░    ░         ░ ░           ░              ░       ░  ░      ░  ░  ░
  `;
  // eslint-disable-next-line no-console
  console.log(`%c${banner}`, 'color: #3b82f6; font-family: monospace;');
  // eslint-disable-next-line no-console
  console.log(
    '%cBuilt with ❤︎ by humans and Claude. Curious how it works? Source is at github.com.',
    'color: #64748b; font-size: 13px;'
  );
  // eslint-disable-next-line no-console
  console.log(
    '%cPS — try the 404 page. There may or may not be a minigame.',
    'color: #94a3b8; font-style: italic; font-size: 12px;'
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
